import { AuthenticationService } from '../core/authentication.service';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Users } from '../models/users';

@Injectable()
export class AuthGuard implements CanActivateChild, CanActivate {

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    const expectedRole = route.data.expectedRole;
    console.log("++++++++++++++++++++++++++++++++++++++++++++++++",expectedRole);

    if ( expectedRole ) {
      console.log(expectedRole);

      return this.auth.hasRole(expectedRole);
    } else {
      console.error(route, 'n\'a pas  d\'expectedRole defined');
      return false;
    }
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    const expectedRole = childRoute.data.expectedRole;
    console.log(expectedRole);

    if (!this.auth.isLoggedIn()) {
      this.router.navigate(['/login']);
      return false;
    } else {
      const canActive = this.auth.hasRole(expectedRole);
      return true;
    }
  }

  constructor(public auth: AuthenticationService, public router: Router) { }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/authentication/authGuard.service.ts